import {
  Component,
  ChangeDetectionStrategy,
  ElementRef,
  Renderer2,
  Input,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  OnInit,
  HostBinding,
} from '@angular/core';

import { GasInputBoolean } from '@cikrf/gas-utils/decorators';

/** @see https://www.figma.com/file/yqBeq1MiGfpdN62SvmA8tg/RTLABS_GAS_DS_1?node-id=589%3A5592 */
@Component({
  // eslint-disable-next-line
  selector: 'input[gasInputField], textarea[gasInputField]',
  templateUrl: './gas-input-field.component.html',
  styleUrls: ['./gas-input-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasInputFieldComponent implements OnChanges, OnInit {
  @GasInputBoolean()
  @Input()
  public required: string | boolean = false;

  @HostBinding('class._error')
  @Input()
  public error = false;

  @HostBinding('class._suffix')
  @Input()
  public suffixIcon = false;

  @HostBinding('class._postfix')
  @Input()
  public postfixIcon = false;

  public requiredEmitter$ = new EventEmitter<boolean>();

  constructor(
    public elementRef: ElementRef,
    public renderer: Renderer2,
  ) {}

  public ngOnInit(): void {
    this.requiredEmitter$.emit(this.required as boolean);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.required) {
      this.requiredEmitter$.emit(changes.required.currentValue);
    }
  }
}
